import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import pinia from '@/store'
import { markStartupRouterReady } from '@/utils/startupExperience'
import setupExtensions from './extensions'
import setupGuards from './guards'
import { shouldUseHtml5History } from './history'
import { constantRoutes } from './routes'

const routeMode = useAppSettingsStore(pinia).settings.app.routeMode ?? 'hash'
const useHtml5History = shouldUseHtml5History(window.location.pathname, routeMode)

const router = createRouter({
  history: useHtml5History ? createWebHistory() : createWebHashHistory(),
  routes: constantRoutes,
  strict: true,
})

setupGuards(router)
setupExtensions(router)

router.isReady().then(() => {
  markStartupRouterReady(router.currentRoute.value.path === '/')
})

export default router
